import AppContext from 'App/AppContext';
import KeyValueTagPicker from 'components/Pickers/KeyValueTagPicker';
import { KeyValueTags } from 'components/Tags/KeyValueTag';
import Tag from 'models/tag';
import { useContext } from 'react';
import { hasUserFeatureGenericManager } from 'services/Auth/featurePermissions';

interface ITaskTagListProps {
  tags: Tag[];
  readOnly?: boolean;
  isLoading: boolean;
  disallowedTags?: Tag[];
  addTagToTaskState: (tag: Tag) => void;
  removeTagFromTaskState: (tag: Tag) => void;
}

export const TaskTagList = (props: ITaskTagListProps) => {
  const appContext = useContext(AppContext);

  //
  // Main render
  //
  const tagsDisplay = props.tags.filter(
    (tag) => !props.disallowedTags?.some((disallowedTag) => disallowedTag.tagId === tag.tagId),
  );

  if (props.readOnly) {
    return <KeyValueTags tags={tagsDisplay} />;
  } else {
    return (
      <KeyValueTagPicker
        selectedTags={tagsDisplay}
        onAdd={props.addTagToTaskState}
        onRemove={props.removeTagFromTaskState}
        onCreate={props.addTagToTaskState}
        isLoading={props.isLoading}
        allowCreate={hasUserFeatureGenericManager(appContext)}
        disallowedTags={props.disallowedTags}
      />
    );
  }
};
